// Balance Sheet Summary Data
export const balanceSheetSummaryData = {
  2024: {
    // ACTIVO
    activoNaoCorrHeader: { label: { pt: 'Activo não corrente', en: 'Non-current Assets' }, isHeader: true },
    assets: [
      { label: { pt: 'Imobilizações Corpóreas', en: 'Tangible Fixed Assets' }, value: 294.0, section: 'noncurrent' },
      { label: { pt: 'Imobilizações Incorpóreas', en: 'Intangible Fixed Assets' }, value: 18.5, section: 'noncurrent' },
    ],
    activoCorrenteHeader: { label: { pt: 'Activo corrente', en: 'Current Assets' }, isHeader: true },
    currentAssets: [
      { label: { pt: 'Existências', en: 'Inventories' }, value: 45.2, section: 'current' },
      { label: { pt: 'Contas a Receber', en: 'Accounts Receivable' }, value: 78.5, section: 'current' },
      { label: { pt: 'Caixa e Equivalentes', en: 'Cash & Equivalents' }, value: 42.0, section: 'current' },
      { label: { pt: 'Outros Activos Correntes', en: 'Other Current Assets' }, value: 7.0, section: 'current' },
    ],
    // CAPITAL PRÓPRIO E PASSIVO
    capitalProprioHeader: { label: { pt: 'Capital próprio', en: 'Equity' }, isHeader: true },
    equity: [
      { label: { pt: 'Capital', en: 'Share Capital' }, value: 150.0, section: 'equity' },
      { label: { pt: 'Reservas', en: 'Reserves' }, value: 45.0, section: 'equity' },
      { label: { pt: 'Resultados Transitados', en: 'Retained Earnings' }, value: 12.9, section: 'equity' },
      { label: { pt: 'Resultados do Exercício', en: 'Net Income' }, value: 37.9, section: 'equity' },
    ],
    passivoNaoCorrenteHeader: { label: { pt: 'Passivo não corrente', en: 'Non-current Liabilities' }, isHeader: true },
    nonCurrentLiabilities: [
      { label: { pt: 'Empréstimos de Médio e Longo Prazos', en: 'Medium & Long-term Loans' }, value: 125.0, section: 'noncurrentliab' },
      { label: { pt: 'Provisões para Outros Riscos', en: 'Provisions for Risks' }, value: 8.5, section: 'noncurrentliab' },
    ],
    passivoCorrenteHeader: { label: { pt: 'Passivo corrente', en: 'Current Liabilities' }, isHeader: true },
    currentLiabilities: [
      { label: { pt: 'Parte Cor. Empr. Médio/Longo Prazos', en: 'Current Portion of LT Debt' }, value: 45.2, section: 'currentliab' },
      { label: { pt: 'Contas a Pagar', en: 'Accounts Payable' }, value: 42.8, section: 'currentliab' },
      { label: { pt: 'Outros Devedores e Credores', en: 'Other Debtors & Creditors' }, value: 17.9, section: 'currentliab' },
    ],
  },
  2025: {
    // ACTIVO
    activoNaoCorrHeader: { label: { pt: 'Activo não corrente', en: 'Non-current Assets' }, isHeader: true },
    assets: [
      { label: { pt: 'Imobilizações Corpóreas', en: 'Tangible Fixed Assets' }, value: 335.9, section: 'noncurrent' },
      { label: { pt: 'Imobilizações Incorpóreas', en: 'Intangible Fixed Assets' }, value: 22.3, section: 'noncurrent' },
    ],
    activoCorrenteHeader: { label: { pt: 'Activo corrente', en: 'Current Assets' }, isHeader: true },
    currentAssets: [
      { label: { pt: 'Existências', en: 'Inventories' }, value: 52.4, section: 'current' },
      { label: { pt: 'Contas a Receber', en: 'Accounts Receivable' }, value: 68.2, section: 'current' },
      { label: { pt: 'Caixa e Equivalentes', en: 'Cash & Equivalents' }, value: 56.0, section: 'current' },
      { label: { pt: 'Outros Activos Correntes', en: 'Other Current Assets' }, value: 8.0, section: 'current' },
    ],
    // CAPITAL PRÓPRIO E PASSIVO
    capitalProprioHeader: { label: { pt: 'Capital próprio', en: 'Equity' }, isHeader: true },
    equity: [
      { label: { pt: 'Capital', en: 'Share Capital' }, value: 150.0, section: 'equity' },
      { label: { pt: 'Reservas', en: 'Reserves' }, value: 65.0, section: 'equity' },
      { label: { pt: 'Resultados Transitados', en: 'Retained Earnings' }, value: 30.8, section: 'equity' },
      { label: { pt: 'Resultados do Exercício', en: 'Net Income' }, value: 54.0, section: 'equity' },
    ],
    passivoNaoCorrenteHeader: { label: { pt: 'Passivo não corrente', en: 'Non-current Liabilities' }, isHeader: true },
    nonCurrentLiabilities: [
      { label: { pt: 'Empréstimos de Médio e Longo Prazos', en: 'Medium & Long-term Loans' }, value: 115.0, section: 'noncurrentliab' },
      { label: { pt: 'Provisões para Outros Riscos', en: 'Provisions for Risks' }, value: 9.5, section: 'noncurrentliab' },
    ],
    passivoCorrenteHeader: { label: { pt: 'Passivo corrente', en: 'Current Liabilities' }, isHeader: true },
    currentLiabilities: [
      { label: { pt: 'Parte Cor. Empr. Médio/Longo Prazos', en: 'Current Portion of LT Debt' }, value: 52.4, section: 'currentliab' },
      { label: { pt: 'Contas a Pagar', en: 'Accounts Payable' }, value: 48.6, section: 'currentliab' },
      { label: { pt: 'Outros Devedores e Credores', en: 'Other Debtors & Creditors' }, value: 17.5, section: 'currentliab' },
    ],
  },
  2026: {
    // ACTIVO
    activoNaoCorrHeader: { label: { pt: 'Activo não corrente', en: 'Non-current Assets' }, isHeader: true },
    assets: [
      { label: { pt: 'Imobilizações Corpóreas', en: 'Tangible Fixed Assets' }, value: 376.5, section: 'noncurrent' },
      { label: { pt: 'Imobilizações Incorpóreas', en: 'Intangible Fixed Assets' }, value: 25.8, section: 'noncurrent' },
    ],
    activoCorrenteHeader: { label: { pt: 'Activo corrente', en: 'Current Assets' }, isHeader: true },
    currentAssets: [
      { label: { pt: 'Existências', en: 'Inventories' }, value: 58.2, section: 'current' },
      { label: { pt: 'Contas a Receber', en: 'Accounts Receivable' }, value: 82.0, section: 'current' },
      { label: { pt: 'Caixa e Equivalentes', en: 'Cash & Equivalents' }, value: 48.0, section: 'current' },
      { label: { pt: 'Outros Activos Correntes', en: 'Other Current Assets' }, value: 8.0, section: 'current' },
    ],
    // CAPITAL PRÓPRIO E PASSIVO
    capitalProprioHeader: { label: { pt: 'Capital próprio', en: 'Equity' }, isHeader: true },
    equity: [
      { label: { pt: 'Capital', en: 'Share Capital' }, value: 150.0, section: 'equity' },
      { label: { pt: 'Reservas', en: 'Reserves' }, value: 85.0, section: 'equity' },
      { label: { pt: 'Resultados Transitados', en: 'Retained Earnings' }, value: 54.2, section: 'equity' },
      { label: { pt: 'Resultados do Exercício', en: 'Net Income' }, value: 69.0, section: 'equity' },
    ],
    passivoNaoCorrenteHeader: { label: { pt: 'Passivo não corrente', en: 'Non-current Liabilities' }, isHeader: true },
    nonCurrentLiabilities: [
      { label: { pt: 'Empréstimos de Médio e Longo Prazos', en: 'Medium & Long-term Loans' }, value: 98.0, section: 'noncurrentliab' },
      { label: { pt: 'Provisões para Outros Riscos', en: 'Provisions for Risks' }, value: 10.2, section: 'noncurrentliab' },
    ],
    passivoCorrenteHeader: { label: { pt: 'Passivo corrente', en: 'Current Liabilities' }, isHeader: true },
    currentLiabilities: [
      { label: { pt: 'Parte Cor. Empr. Médio/Longo Prazos', en: 'Current Portion of LT Debt' }, value: 58.2, section: 'currentliab' },
      { label: { pt: 'Contas a Pagar', en: 'Accounts Payable' }, value: 56.1, section: 'currentliab' },
      { label: { pt: 'Outros Devedores e Credores', en: 'Other Debtors & Creditors' }, value: 17.8, section: 'currentliab' },
    ],
  },
};
